@if (countrySelectorService.displayIsoCodes$ | async; as displayIsocodes) {
  @if (countrySelectorService.langIsoCodes$ | async; as langIsoCodeArray) {
    <ul class="inline-list" [ngClass]="isLoggedIn?'smFlag':''">
      @if (langService.getActive()|async; as lang) {
        @for (displayIsocode of displayIsocodes; track displayIsocode; let i = $index) {
          <app-lang-sub [ngClass]="{'lang-Active-one': languageIsoCode === displayIsocode}">
            <li class="inline-item">
              <span class="inline-item-link"
                (click)="languageChange(displayIsocode, langIsoCodeArray[i], 'NA', $event)">
                {{ displayIsocode }}
              </span>
              @if (!i) {
                <span class="lang-seprator-ui"></span>
              }
            </li>
          </app-lang-sub>
        }
      }
    </ul>
  }
}